import { IconName } from '@usealloy/component-library';
import type { BadgeProps } from '@usealloy/component-library';

/** Takes in a supplied data verified status and returns appropriate badge props */
export const getVerifiedBadgeProps = (verifiedStatus?: boolean): {
  text: string;
  status: BadgeProps['status'];
  iconName: BadgeProps['icon'];
} => {
  if (verifiedStatus === true) {
    return {
      text: 'Pass',
      status: 'eventSuccess',
      iconName: IconName.CircleCheck,
    };
  }

  if (verifiedStatus === false) {
    return {
      text: 'Fail',
      status: 'danger',
      iconName: IconName.CircleClose,
    };
  }

  return {
    text: 'Not evaluated by a service',
    status: 'neutral',
    iconName: IconName.Minus,
  };
};
